// @ts-expect-error Untyped module
import { SALES_SIGNUP } from 'growth-onboarding-signup-redirect/constants/signupConstants';
import { Flow } from 'signup-constants/Flow';
import { Integration } from 'signup-constants/Integration';
import { getFlowKey } from '../routing/getFlowKey';
import { getIntegrationKey } from '../routing/getIntegrationKey';
import { getStandaloneCmsPartnerRedirect } from '../standalone-cms-partner/getStandaloneCmsPartnerRedirect';
import { getTrialRedirect } from '../trial/getTrialRedirect';
import { isOauthFlow } from '../utils/oauthUtils';
import { getAcademyRedirect } from './academyRedirect';
import { getCMSDeveloperRedirect } from './cmsDeveloperRedirect';
import { getDeveloperRedirect } from './developerRedirect';
import { getDirectoryListingRedirect } from './directoryListingRedirect';
import { getConnectFlowRedirect } from './getConnectFlowRedirect';
import { getFacebookCrmRedirect } from './getFacebookCrmRedirect';
import { getOauthRedirect } from './getOauthRedirect';
import { getSolutionsProviderRedirect } from './getSolutionsProviderRedirect';
import { getWordPressRedirect } from './getWordPressRedirect';
import { getHubSpotForNonprofitsRedirect, getHubSpotForStartupsRedirect, getHubSpotPartnersRedirect } from './hubspotForXRedirect';
const SpecificRedirect = new Map([[Flow.Academy, getAcademyRedirect], [Flow.Developers, getDeveloperRedirect], [Flow.CmsDevelopers, getCMSDeveloperRedirect], [Flow.HubspotForStartups, getHubSpotForStartupsRedirect], [Flow.SolutionsProvider, getSolutionsProviderRedirect], [Flow.DirectoryListing, getDirectoryListingRedirect], [Flow.HubspotForNonprofits, getHubSpotForNonprofitsRedirect], [Flow.HubSpotPartners, getHubSpotPartnersRedirect], [Flow.FbCrm, getFacebookCrmRedirect], [Integration.Wordpress, getWordPressRedirect], [Flow.Trial, getTrialRedirect], [Flow.StandaloneCmsPartner, getStandaloneCmsPartnerRedirect], [Flow.Connect, getConnectFlowRedirect]]);
const SpecificEnrollment = new Map([[Flow.HubspotForStartups, SALES_SIGNUP]]);

function getFlowOrIntegrationKey() {
  const flowKey = getFlowKey();
  const integrationKey = getIntegrationKey();
  return integrationKey || flowKey;
}

export const getSpecificRedirect = () => {
  const specificRedirect = SpecificRedirect.get(getFlowOrIntegrationKey());
  return isOauthFlow() ? getOauthRedirect : specificRedirect;
};
export const getSpecificEnrollment = () => {
  return SpecificEnrollment.get(getFlowOrIntegrationKey());
};